export default __webpack_public_path__ + "static/media/wwg-long-sleeve.36dbdfdb.png";